export function extractFileName(uri: string) {
    return decode(getLastPart(uri));
}

export function decode(uri: string) {
    return window.decodeURI(uri);
}

export function getLastPart(uri: string | undefined | null) {
    return uri?.match(/.+\/(.*)$/)?.[1] ?? '';
}

export function stripScheme(uri: string | undefined | null) {
    return uri?.match('https?://(.*)$')?.[1] ?? '';
}

export function split(uri: string) {
    const m = uri?.match('(https?://)?(.*?)$');

    if (!m) {
        return [];
    }

    const scheme = m[1];
    const rest = m[2];
    const parts = rest.split('/');
    return scheme ? [scheme].concat(parts) : parts;
}

export function matchesHostname(uri: string, hostname: string) {
    try {
        return new URL(uri).hostname === hostname;
    } catch {
        return false;
    }
}
